$(document).ready(function () {
    var json_len = abcsetup.userOrg.org_attribute.length;
    var alcohol_perc_sel = false;
    if (json_len > 0) {
        const $tradeAgreement = $("#trade_agreement");
        $(abcsetup.userOrg.org_attribute).each(function() {
            if (this.taa_compliant_exempt && this.taa_compliant_exempt == 'Y') {
                window.fieldValidate.removeOrnaments($tradeAgreement);
                $tradeAgreement.attr('required', false);
                $tradeAgreement.closest("div.form-group").removeAttr("requiredIf").removeClass("required");
            }

            if (this.country_origin_exempt && this.country_origin_exempt == 'Y') {
                window.fieldValidate.removeOrnaments($("select[name='country_origin[]']"));
                $("select[name='country_origin[]']").attr('required', false);
                $("input[name='country_origin']").attr('required', false);
                $("select[name='country_origin[]']").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
            }
        });
    }

    const init_class = abcsetup.item && abcsetup.item.role ? abcsetup.item.role.class : '';

    if ($("#type").val() === 'brx') {
        $("#application").find('[value="ANDA"]').remove();
    }

    if ($("#type").val() === 'otg') {
        //disabled 12/19/2022 upon lindsays request for ticket abcs-1235 -ke
        /* $('#mat_group').val('OTG');
        $('#mat_group').attr('disabled', true).addClass('readonly');
        $('#mat_group').after('<input type="hidden" id="mat_group" name="mat_group" value="OTG">'); */
    }

    if ($("#type").val() === 'grx') {
        $("#rx_group").hide();
    }

    if (init_class == 'gsmd_team') {
        $("#transmit_uom_case").val('Y').trigger("change");
        $("#transmit_uom_case").addClass('readonly').attr('disabled', true);
        $('#transmit_uom_case').after('<input type="hidden" id="transmit_uom_case" name="transmit_uom_case" value="Y">');

        // ABCS-5134 - GSMD Team copies an Rx Item then remove the required for the NDC10 Format and NDC10
        if ($("#item_setup_reason_admin").val() === '11') {
            $('label[for="unit_dose_ndc10_format"]').closest('div.required[requiredif]').removeClass('required');
            $('label[for="unit_dose_ndc10"]').closest('div.required[requiredif]').removeClass('required');
            $("#unit_dose_ndc10_format").attr('required', false);
            $("#unit_dose_ndc10").attr('required', false);
        }
    }

    /*
    Required logic for identifiers
    */
    $(".article_identifiers").change(function() {
        var this_css_class;
        var css_classes = ["article_identifiers"];
        for (var idx in css_classes) {
            if ($(this).hasClass(css_classes[idx])) {
                this_css_class = css_classes[idx];
                break;
            }
        }
        //console_log(this_css_class+":"+$(this).attr("name")+":"+$(this).val());
        var at_least_one = false;
        $("."+this_css_class).each(function() {
            if ($(this).val()) {
                at_least_one = true;
                return;
            }
        });
        $("."+this_css_class).each(function() {
            if (!at_least_one) {
                $(this).attr('required', true);
                $(this).closest("div.form-group").addClass("required");
            }
            else if ($(this).val()) {
                $(this).attr('required', true);
                $(this).closest("div.form-group").addClass("required");
            }
            else {
                window.fieldValidate.removeOrnaments(this);
                $(this).attr('required', false);
                $(this).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
            }
        });
    }).trigger("change");

    // Check if the user or item role is specialy and not ahp_cm - and set shipment_info to drop_ship
    if (abcsetup.userRole.class == 'bluepoint_cm') {
        $('#shipment_info').val('drop_ship').trigger("change");
        if ($('#shipment_info:visible').length) {
            abcsetup.fieldLib._readOnlyField($('#shipment_info'), true);
            $('.field-value.shipment_info .value').html('Drop-Ship Only')
        }

        $('.enable_sap_division').each(function () {
            if ($(this).val() == '10') {
                $(this).prop("checked", true);
                $(this).trigger("change");
                $(this).attr("disabled",true);
            }
            else {
                $(this).prop("checked", false);
                $(this).trigger("change");
                $(this).attr("disabled",true);
            }
        });
    }

    // Check if the user or item role is specialy and ahp_cm - and set shipment_info to direct-ship only
    if (abcsetup.userRole.class == 'ahp_cm') {
        $('#shipment_info').val('direct_ship').trigger("change");
        if ($('#shipment_info:visible').length) {
            abcsetup.fieldLib._readOnlyField($('#shipment_info'), true);
            $('.field-value.shipment_info .value').html('Direct-Ship Only')
        }
    }

    $(".pack_info").change(function () {
        const $packInfo = $(".pack_info");
        if ($(this).val() != '') {
            $packInfo.attr('required', true);
            $packInfo.closest("div.form-group").addClass("required");
        } else if ($("#pack_weight").val() == '' && $("#pack_depth").val() == '' && $("#pack_height").val() == '' && $("#pack_width").val() == '' && $("#pack_pieces").val() == '') {
            window.fieldValidate.removeOrnaments($packInfo);
            $packInfo.attr('required', false);
            $packInfo.closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }
    }).trigger("change");

    $(".pallet_info").change(function() {
        const $palletInfo = $(".pallet_info");
        if ($(this).val() != '') {
            $palletInfo.attr('required', true);
            $palletInfo.closest("div.form-group").addClass("required");
        } else if ($("#pallet_weight").val() == '' && $("#pallet_depth").val() == '' && $("#pallet_height").val() == '' && $("#pallet_width").val() == '' && $("#pallet_pieces").val() == '') {
            window.fieldValidate.removeOrnaments($palletInfo);
            $palletInfo.attr('required', false);
            $palletInfo.closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }
    }).trigger("change");



    $("#dscsa_exempt").change(function() {
        if (abcsetup.userRole.class == 'gsmd_team') {
            return true;
        }
        var dscsa_exempt = $(this).val();
        if (dscsa_exempt == 'N') {
            $('.enable_gtin_level').each(function () {
                if ($(this).val() == 'item' || $(this).val() == 'case') {
                    $(this).prop("checked", true);
                    $(this).trigger("change");
                    $(this).attr("disabled",true);
                }
            });
        }
        else {
            $('.enable_gtin_level').each(function () {
                if ($(this).val() == 'item' || $(this).val() == 'case') {
                    if ($(this).is(":disabled")) {
                        $(this).attr("disabled",false);
                        $(this).prop("checked", false);
                    }
                    $(this).trigger("change");
                }
            });
        }

        if (dscsa_exempt == 'WEE') {
            $("#dscsa_exempt_reason").val("18").attr('disabled',true).addClass('readonly');
            $("#dscsa_exempt_reason").after('<input type="hidden" id="dscsa_exempt_reason" name="dscsa_exempt_reason" value="18">');
            $("#serialized").val("Y").attr('disabled',true).addClass('readonly');
            $("#serialized").after('<input type="hidden" id="serialized" name="serialized" value="Y">');
        }
        else if (dscsa_exempt == 'N' || dscsa_exempt == 'Y' || dscsa_exempt == '') {
            if ($("#dscsa_exempt_reason").val() == '18') {
                $("#dscsa_exempt_reason").val("").attr('disabled',false).removeClass('readonly');
                $("input[id='dscsa_exempt_reason']").remove();
            }
            $("#serialized").val("").attr('disabled',false).removeClass('readonly');
            $("input[id='serialized']").remove();
        }

        //if (RX_ITEM.is_specialty_role(RX_ITEM.user_role)) {
        //   $('.gtin_grid_gtin_14').each(function () {
        //      $(this).siblings('.input_required_indicator').remove();
        //      $(this).removeClass("required");
        //      $(this).attr("required",false);
        //   });
        //}
    }).trigger("change");

    $("#listed_chemical").change(function() {
        if ($(this).val() != 'Y') {
            $("#chemical").val('').after('<input type="hidden" id="chemical" name="chemical" class="hidden_listed_chemical" value="">');
            $("#chemical_other").val('').after('<input type="hidden" id="chemical_other" name="chemical_other" class="hidden_listed_chemical" value="">');
            $("#chemical_ingredient_amount").val('').after('<input type="hidden" id="chemical_ingredient_amount" name="chemical_ingredient_amount" class="hidden_listed_chemical" value="">');
            $("#chemical_ingredient_uom").val('').after('<input type="hidden" id="chemical_ingredient_uom" name="chemical_ingredient_uom" class="hidden_listed_chemical" value="">');
            $("#chemical_category").val('').after('<input type="hidden" id="chemical_category" name="chemical_category" class="hidden_listed_chemical" value="">');
        }
        else {
            $(".hidden_listed_chemical").remove();
        }
    }).trigger("change");


    $("#retail_sticker_qty").val(1);

    if ($("#item_pieces").val() == "") {
        $("#item_pieces").val("1");
    }
    $("#item_pieces").change(function() {
        var item_pieces = $(this).val();
        $('.enable_gtin_level').each(function () {
            var enabled = $(this).is(':checked');
            if ($(this).val() == 'item') {
                if (!enabled) {
                    return;
                }
                else {
                    $("input[name='gtin_items[item][qty]']").val(item_pieces);
                    if (item_pieces != '') {
                        $("input[name='gtin_items[item][qty]']").attr("readonly",true).addClass("readonly");
                    }
                    else {
                        $("input[name='gtin_items[item][qty]']").attr("readonly",false).removeClass("readonly");
                    }
                }
            }
        });

        var pack_pieces = $("#pack_pieces").val();
        var pieces_check = Math.round((pack_pieces/item_pieces) * 100.0) / 100.0;

        if (pieces_check % 1 === 0) {
            window.fieldValidate.removeOrnaments($("#item_pieces"));
            $("#item_pieces").attr('required', false);
            $("#item_pieces").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }
    });

    if ($("input[name='gtin_items[item][qty]']").val() == $("#item_pieces").val()) {
        $("#item_pieces").trigger("change");
    }

    $("#pack_pieces").change(function() {
        var pack_pieces = $(this).val();
        $('.enable_gtin_level').each(function () {
        var enabled = $(this).is(':checked');
            if ($(this).val() == 'inner') {
                if (!enabled) {
                    return;
                }
                else {
                    $("input[name='gtin_items[inner][qty]']").val(pack_pieces);
                    if (pack_pieces != '') {
                        $("input[name='gtin_items[inner][qty]']").attr("readonly",true).addClass("readonly");
                    }
                    else {
                        $("input[name='gtin_items[inner][qty]']").attr("readonly",false).removeClass("readonly");
                    }
                }
            }
        });

        var item_pieces = $("#item_pieces").val();
        var case_pieces = $("#case_pieces").val();
        var pieces_check = Math.round((pack_pieces/item_pieces) * 100.0) / 100.0;

        if (pieces_check % 1 === 0) {
            window.fieldValidate.removeOrnaments($("#pack_pieces"));
            $("#pack_pieces").attr('required', false);
            $("#pack_pieces").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }

        pieces_check = Math.round((case_pieces/pack_pieces) * 100.0) / 100.0;

        if (pieces_check % 1 === 0) {
            window.fieldValidate.removeOrnaments($("#pack_pieces"));
            $("#pack_pieces").attr('required', false);
            $("#pack_pieces").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }
    });

    if ($("input[name='gtin_items[inner][qty]']").val() == $("#pack_pieces").val()) {
        $("#pack_pieces").trigger("change");
    }

    $("#case_pieces").change(function() {
        var case_pieces = $(this).val();
        $('.enable_gtin_level').each(function () {
            var enabled = $(this).is(':checked');
            if ($(this).val() == 'case') {
                if (!enabled) {
                    return;
                }
                else {
                    $("input[name='gtin_items[case][qty]']").val(case_pieces);
                    if (case_pieces != '') {
                        $("input[name='gtin_items[case][qty]']").attr("readonly",true).addClass("readonly");
                    }
                    else {
                        $("input[name='gtin_items[case][qty]']").attr("readonly",false).removeClass("readonly");
                    }
                }
            }
        });

        var pack_pieces = $("#pack_pieces").val();
        var pallet_pieces = $("#pallet_pieces").val();
        var pieces_check = Math.round((case_pieces/pack_pieces) * 100.0) / 100.0;

        if (pieces_check % 1 === 0) {
            window.fieldValidate.removeOrnaments($("#case_pieces"));
            $("#case_pieces").attr('required', false);
            $("#case_pieces").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }

        pieces_check = Math.round((pallet_pieces/case_pieces) * 100.0) / 100.0;

        if (pieces_check % 1 === 0) {
            window.fieldValidate.removeOrnaments($("#case_pieces"));
            $("#case_pieces").attr('required', false);
            $("#case_pieces").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }
    });

    if ($("input[name='gtin_items[case][qty]']").val() == $("#case_pieces").val()) {
        $("#case_pieces").trigger("change");
    }

    $("#pallet_pieces").change(function() {
        var pallet_pieces = $(this).val();
        $('.enable_gtin_level').each(function () {
            var enabled = $(this).is(':checked');
            if ($(this).val() == 'pallet') {
                if (!enabled) {
                    return;
                }
                else {
                    $("input[name='gtin_items[pallet][qty]']").val(pallet_pieces);
                    if (pallet_pieces != '') {
                        $("input[name='gtin_items[pallet][qty]']").attr("readonly",true).addClass("readonly");
                    }
                    else {
                        $("input[name='gtin_items[pallet][qty]']").attr("readonly",false).removeClass("readonly");
                    }
                }
            }
        });

        var case_pieces = $("#case_pieces").val();
        var pieces_check = Math.round((pallet_pieces/case_pieces) * 100.0) / 100.0;

        if (pieces_check % 1 === 0) {
            window.fieldValidate.removeOrnaments($("#pallet_pieces"));
            $("#pallet_pieces").attr('required', false);
            $("#pallet_pieces").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }
    });

    if ($("input[name='gtin_items[pallet][qty]']").val() == $("#pallet_pieces").val()) {
        $("#pallet_pieces").trigger("change");
    }

    $("#item_setup_reason").change(function() {
        var item_setup_reason = $(this).val();
        if (item_setup_reason == "Short Dated") {
            $("#short_dated_prod").val("Y").trigger("change");
            //$("#short_dated_offer_letter").addClass("required").show();
        }
        else {
            //$("#short_dated_offer_letter").removeClass("required").hide();
        }

        // ABCS-5134 - GSMD Team copies an Rx Item then remove the required for the NDC10 Format and NDC10
        if (item_setup_reason == "GSMD Copied RX Setup") {
            $('label[for="unit_dose_ndc10_format"]').closest('div.required[requiredif]').removeClass('required');
            $('label[for="unit_dose_ndc10"]').closest('div.required[requiredif]').removeClass('required');
            $("#unit_dose_ndc10_format").attr('required', false);
            $("#unit_dose_ndc10").attr('required', false);
        }
    }).trigger("change", {initialRun: true});

    $(".moq").change(function() {
        var this_css_class;
        var css_classes = ["moq"];
        for (var idx in css_classes) {
            if ($(this).hasClass(css_classes[idx])) {
                this_css_class = css_classes[idx];
                break;
            }
        }
        //console_log(this_css_class+":"+$(this).attr("name")+":"+$(this).val());
        var at_least_one = false;
        $("."+this_css_class).each(function() {
            if ($(this).val()) {
                at_least_one = true;
                return;
            }
        });
        $("."+this_css_class).each(function() {
            if (!at_least_one) {
                $(this).attr('required', true);
                $(this).closest("div.form-group").addClass("required");
            }
            else if ($(this).val()) {
                $(this).attr('required', true);
                $(this).closest("div.form-group").addClass("required");
            }
            else {
                window.fieldValidate.removeOrnaments(this);
                $(this).attr('required', false);
                $(this).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
            }
        });
    }).trigger("change", {initialRun: true});

    $.each(['selling_unit','individual_unit','unit_dose'],function() {
        var uom = this;

        /*if (user_role == 'field_team') {
        $("input[name='rx_item["+uom+"_ndc]']").closest("tr").show();
        $("input[name='rx_item["+uom+"_ndc]']").siblings(".input_required_indicator").remove();
        $("input[name='rx_item["+uom+"_ndc]']").closest("td").removeClass("readonly");
        $("input[name='rx_item["+uom+"_ndc]']").after('<span class="input_required_indicator">*</span>');
        }*/

        $("#"+uom+"_ndc10_format").change(function() {
            var ndc10_format = $(this).val();
            var ndc10 = $("#"+uom+"_ndc10");
            var ndc11 = $("#"+uom+"_ndc");

            if (ndc10_format && ndc10_format.length) {
                ndc10.closest("tr").show();

                /*if (user_role == 'field_team') {
                    ndc11.siblings(".input_required_indicator").hide();
                }*/

                switch (ndc10_format) {
                    case "4-4-2":
                        $('input.currency').mask('###0.00', {reverse: true});
                        ndc10.mask("9999-9999-99", {reverse: true});
                        break;
                    case "5-3-2":
                        ndc10.mask("99999-999-99", {reverse: true});
                        break;
                    case "5-4-1":
                        ndc10.mask("99999-9999-9", {reverse: true});
                        break;
                }
                // Trigger change to allow article_identifier logic to update required fields
                ndc10.trigger('change');
            }
            else {
                /*if (user_role == 'field_team') {
                    ndc11.siblings(".input_required_indicator").show();
                }*/

                // Related to changes for ticket ABCS-2687
                // The format field is no longer required, hence the ndc10 value should not be cleared out if this field is empty
                // ndc10.val("").closest("tr").hide();

        //                if (user_role != 'field_team') {
        //                   ndc11.val("").trigger("change");
        //                }
            }

            if (ndc11.val() && ndc11.val().length) {
                ndc11.trigger("change");
            }
        }).trigger("change", {initialRun: true});

        $("#"+uom+"_ndc10").change(function() {
            var ndc10 = $(this).val();
            var ndc10_format = $("#"+uom+"_ndc10_format").val();
            var ndc11 = $("#"+uom+"_ndc");

            if (ndc10.length) {
                switch (ndc10_format) {
                    case "4-4-2":
                        var str = "0" + ndc10.replace(/\-/g,"");
                        ndc11.val(str);
                        break;
                    case "5-3-2":
                        var str = ndc10.substr(0, 5) + "0" + ndc10.substr(6, 3) + ndc10.substr(10, 2);
                        ndc11.val(str);
                        break;
                    case "5-4-1":
                        var str = ndc10.substr(0, 5) + ndc10.substr(6, 4)  + "0" + ndc10.substr(11, 1);
                        ndc11.val(str);
                        break;
                }
            }
            else {
        //                if (user_role != 'field_team') {
        //                   ndc11.val("").trigger("change");
        //                }
            }

        }).trigger("change", {initialRun: true});

        $("#"+uom+"_ndc").change(function() {
            var ndc11 = $(this).val();
            var ndc10_format = $("#"+uom+"_ndc10_format");
            var ndc10 = $("#"+uom+"_ndc10");

            if (ndc11.length) {
                /*if (user_role == 'field_team') {
                    if (uom == 'selling_unit') {
                        if (ndc11.length == 11) {
                        ndc10_format.siblings(".input_required_indicator").hide();
                        //ndc10_format.rules('remove','required');
                        }
                        else {
                        ndc10_format.siblings(".input_required_indicator").show();
                        }
                    }
                }*/

                switch (ndc10_format.val()) {
                    case "4-4-2":
                        var str = ndc11.substr(1, 4) + "-" + ndc11.substr(5, 4) + "-" + ndc11.substr(9, 2);
                        ndc10.val(str);
                        break;
                    case "5-3-2":
                        var str = ndc11.substr(0, 5) + "-" + ndc11.substr(6, 3) + "-" + ndc11.substr(9, 2);
                        ndc10.val(str);
                        break;
                    case "5-4-1":
                        var str = ndc11.substr(0, 5) + "-" + ndc11.substr(5, 4)  + "-" + ndc11.substr(10, 1);
                        ndc10.val(str);
                        break;
                }
                // Trigger change to allow article_identifier logic to update required fields
                ndc10.trigger('change');
            }
            else {
                /*if (user_role == 'field_team') {
                    ndc10_format.siblings(".input_required_indicator").show();
                }*/
            }

        }).trigger("change", {initialRun: true});
    });

    $("#duns").on('keydown', function(event) {
        // Should this just be a number field?
        const invalidChars = {dash: 189};
        return !Object.values(invalidChars).includes(event.which);
    }).trigger("keydown", {initialRun: true});

    $("#pr_registration").change(function() {
        var pr_registration = $(this).val();
        if (pr_registration === "Y") {
        //$("select[name='rx_item[high_priority_item]']").closest("tr").show();
        //$('button#pr_registration_doc').addClass('required btn-danger');
        $("pr_reg_coding").val("RRC");
        }
        else if (pr_registration === "in_process") {
            if (abcsetup.userRole.class === 'vendor' || abcsetup.userRole.class === 'rx_vendor') {
                abcsetup.alerts.show("Warning: Puerto Rico Distribution: In Process", "By selecting 'In Process', you are indicating that your company has initiated registering this item for sale in Puerto Rico, but have not yet received the registration documentation from the Puerto Rico Department of Health. <br><br><font style='bold' color='#F03200'>YOU WILL NEED TO SUBMIT THE REGISTRATION DOCUMENT AS SOON AS YOU OBTAIN IT.</font>");
            }
            //$("select[name='rx_item[high_priority_item]']").closest("tr").show();
            //$('button#pr_registration_doc').removeClass('required btn-danger');
        }
        else {
            //$("select[name='rx_item[high_priority_item]']").closest("tr").hide();
            //$("#pr_registration_doc").removeClass("btn-required").hide();
            //$('button#pr_registration_doc').removeClass('required btn-danger');
        }
    }).trigger("change", {initialRun: true});

    $(function() {
        if ($("#pr_registration").val() != "") {
            if (abcsetup.item && abcsetup.item.pr_registration != $("#pr_registration").val()) {
                $("#pr_registration").trigger("change");
            }
        }
        else {
            //$("#pr_registration_doc").removeClass("btn-required").hide();
            //$('button#pr_registration_doc').removeClass('required btn-danger');
        }
    });

    $(function() {
        if (abcsetup.userRole.class == 'bluepoint_cm') {
            var field = $('input.attachment_file[data-idx="flat_product_bar_code_image"]');
            $("button[id='flat_product_bar_code_image']").removeClass("btn-required btn-danger required");
            field.hide().attr('required', false);
        }
    });

    //volume calculation
    $.each(['item','pack','case','pallet'],function() {
        var uom = this;
        $("#"+uom+"_height").change(function(){
            if ($.isNumeric($(this).val()) && $.isNumeric($("#"+uom+"_width").val()) && $.isNumeric($("#"+uom+"_depth").val())) {
                var volume = $(this).val() * $("#"+uom+"_width").val() * $("#"+uom+"_depth").val();
                $("#"+uom+"_volume").val(Math.round(volume * 100) / 100);
            }
            else {
                $("#"+uom+"_volume").val("");
            }
        }).trigger("change", {initialRun: true});
        $("#"+uom+"_width").change(function(){
            if ($.isNumeric($(this).val()) && $.isNumeric($("#"+uom+"_height").val()) && $.isNumeric($("#"+uom+"_depth").val())) {
                var volume = $(this).val() * $("#"+uom+"_height").val() * $("#"+uom+"_depth").val();
                $("#"+uom+"_volume").val(Math.round(volume * 100) / 100);
            }
            else {
                $("#"+uom+"_volume").val("");
            }
        }).trigger("change", {initialRun: true});
        $("#"+uom+"_depth").change(function(){
            if ($.isNumeric($(this).val()) && $.isNumeric($("#"+uom+"_height").val()) && $.isNumeric($("#"+uom+"_width").val())) {
                var volume = $(this).val() * $("#"+uom+"_height").val() * $("#"+uom+"_width").val();
                $("#"+uom+"_volume").val(Math.round(volume * 100) / 100);
            }
            else {
                $("#"+uom+"_volume").val("");
            }
        }).trigger("change", {initialRun: true});
    });

    $("#blood_product").change(function() {
        var tmpID = abcsetup.randomString();
        var flu_product = $("#flu_product");
        var vac_product = $("#vaccine_product");
        var oral_med_product = $("#oral_med_product");

        if ($(this).val() == 'Y') {
            flu_product.val("N").attr('disabled',true).addClass('readonly');
            flu_product.after('<input type="hidden" id="' + flu_product.attr('id') + '" name="' + flu_product.attr('id') + '" value="N">');

            vac_product.val("N").attr('disabled',true).addClass('readonly');
            vac_product.after('<input type="hidden" id="' + vac_product.attr('id') + '" name="' + vac_product.attr('id') + '" value="N">');

            oral_med_product.val("N").attr('disabled',true).addClass('readonly');
            oral_med_product.after('<input type="hidden" id="' + oral_med_product.attr('id') + '" name="' + oral_med_product.attr('id') + '" value="N">');
        }
        else {
            if (flu_product.val() != 'Y' && vac_product.val() != 'Y' && oral_med_product.val() != 'Y') {
                flu_product.attr('disabled',false).removeClass('readonly');
                $("input[id='flu_product']").remove();
                vac_product.attr('disabled',false).removeClass('readonly');
                $("input[id='vaccine_product']").remove();
                oral_med_product.attr('disabled',false).removeClass('readonly');
                $("input[id='oral_med_product']").remove();
            }
        }
    }).trigger("change");

    $("#flu_product").change(function() {
        var tmpID = abcsetup.randomString();
        var blood_product = $("#blood_product");
        var vac_product = $("#vaccine_product");
        var oral_med_product = $("#oral_med_product");

        if ($(this).val() == 'Y') {
            blood_product.val("N").attr('disabled',true).addClass('readonly');
            blood_product.after('<input type="hidden" id="' + blood_product.attr('id') + '" name="' + blood_product.attr('id') + '" value="N">');

            vac_product.val("N").attr('disabled',true).addClass('readonly');
            vac_product.after('<input type="hidden" id="' + vac_product.attr('id') + '" name="' + vac_product.attr('id') + '" value="N">');

            oral_med_product.val("N").attr('disabled',true).addClass('readonly');
            oral_med_product.after('<input type="hidden" id="' + oral_med_product.attr('id') + '" name="' + oral_med_product.attr('id') + '"value="N">');
        }
        else {
            if (blood_product.val() != 'Y' && vac_product.val() != 'Y' && oral_med_product.val() != 'Y') {
                blood_product.attr('disabled',false).removeClass('readonly');
                $("input[id='blood_product']").remove();
                vac_product.attr('disabled',false).removeClass('readonly');
                $("input[id='vaccine_product']").remove();
                oral_med_product.attr('disabled',false).removeClass('readonly');
                $("input[id='oral_med_product']").remove();
            }
        }
    }).trigger("change");

    $("#vaccine_product").change(function() {
        var tmpID = abcsetup.randomString();
        var blood_product = $("#blood_product");
        var flu_product = $("#flu_product");
        var oral_med_product = $("#oral_med_product");
        var rx_group = $("#rx_group");

        if ($(this).val() == 'Y') {
            blood_product.val("N").attr('disabled',true).addClass('readonly');
            blood_product.after('<input type="hidden" id="' + blood_product.attr('id') + '" name="' + blood_product.attr('id') + '" value="N">');

            flu_product.val("N").attr('disabled',true).addClass('readonly');
            flu_product.after('<input type="hidden" id="' + flu_product.attr('id') + '" name="' + flu_product.attr('id') + '" value="N">');

            oral_med_product.val("N").attr('disabled',true).addClass('readonly');
            oral_med_product.after('<input type="hidden" id="' + oral_med_product.attr('id') + '" name="' + oral_med_product.attr('id') + '" value="N">');

            rx_group.val("03").attr("disabled",true).parent("td").addClass("readonly");
            rx_group.after('<input type="hidden" name="rx_group" value="03">');
        } else {
            rx_group.attr("disabled",false).parent("td").removeClass("readonly");
            $("input[name='rx_group']").remove();
            if (blood_product.val() != 'Y' && flu_product.val() != 'Y' && oral_med_product.val() != 'Y') {
                blood_product.attr('disabled',false).removeClass('readonly');
                $("input[id='blood_product']").remove();
                flu_product.attr('disabled',false).removeClass('readonly');
                $("input[id='flu_product']").remove();
                oral_med_product.attr('disabled',false).removeClass('readonly');
                $("input[id='oral_med_product']").remove();
            }
        }
    }).trigger("change");

    $("#oral_med_product").change(function() {
        var tmpID = abcsetup.randomString();
        var blood_product = $("#blood_product");
        var flu_product = $("#flu_product");
        var vac_product = $("#vaccine_product");
        var product_type = $("#product_type");

        if ($(this).val() == 'Y') {
            blood_product.val("N").attr('disabled',true).addClass('readonly');
            blood_product.after('<input type="hidden" id="' + blood_product.attr('id') + '" name="' + blood_product.attr('id') + '" value="N">');

            flu_product.val("N").attr('disabled',true).addClass('readonly');
            flu_product.after('<input type="hidden" id="' + flu_product.attr('id') + '" name="' + flu_product.attr('id') + '" value="N">');

            vac_product.val("N").attr('disabled',true).addClass('readonly');
            vac_product.after('<input type="hidden" id="' + vac_product.attr('id') + '" name="' + vac_product.attr('id') + '" value="N">');

            // product_type.val("OMD");//.attr("disabled",true).parent("td").addClass("readonly");
        }
        else {
            if (blood_product.val() != 'Y' && flu_product.val() != 'Y' && vac_product.val() != 'Y') {
                blood_product.attr('disabled',false).removeClass('readonly');
                $("input[id='blood_product']").remove();
                vac_product.attr('disabled',false).removeClass('readonly');
                $("input[id='vaccine_product']").remove();
                flu_product.attr('disabled',false).removeClass('readonly');
                $("input[id='flu_product']").remove();
            }
        }
    }).trigger("change");

    $("#form").change(function() {
        var form_val = $(this).val();
        var oral_med_form = [
            "CAP",
            "CPL",
            "CHW",
            "CTB",
            "CRY",
            "ELX",
            "EXP",
            "GMY",
            "GCP",
            "GTB",
            "GRN",
            "GUM",
            "INH",
            "LCP",
            "LGL",
            "LOZ",
            "ORS",
            "PUD",
            "SYR",
            "SGC",
            "SGT",
            "TAB",
            "WAF"];

            if (oral_med_form.indexOf(form_val) > -1) {
                $("#oral_med_product").val("Y").trigger("change").addClass("readonly").attr('disabled',true);
                $("#oral_med_product").after('<input type="hidden" id="oral_med_product" name="oral_med_product" value="Y">');
            }
            else {
                $("#oral_med_product").val("").trigger("change").removeClass("readonly").attr('disabled',false);
                $("input[id='oral_med_product']").remove();
            }
    }).trigger("change");

    $(".product_type").change(function() {
        var product_type = $("#product_type");
        var prod_type_obj = {};

        if ($(this).val() == 'Y') {
            var type = $(this).attr("id");
            type_part = type.match(/(\w+)_product/)[1];
            console.log("abc_item/product_type: "+type_part);

            // Do not re-populate the Product Type select list if the 'injectable_product' question was changed
            // Values for Product Type are determined by the blood-,flu-,vaccine-,oral_med-, and med_surge-product questions
            if (type_part=='injectable') return;

            $.ajax({
                type: "POST",
                url: "/api/abc_item/product_type",
                cache: false,
                dataType: 'json',
                data: {type: type_part},
                success: function(result) {
                    console.log("abc_item/product_type->"+JSON.stringify(result,{},4));
                    // if (type_part != 'oral_med') {
                        product_type.empty().append($("<option></option>").attr("value","").text("-select-"));
                    // }
                    // else {
                        // product_type.empty();
                    // }

                    if (!$.isEmptyObject(result)) {
                        prod_type_obj = result;
                        prod_type_obj.forEach(function(prod_type) {
                            product_type.append($("<option></option>").attr("value",prod_type.id).text(prod_type.name));
                        });
                        if (abcsetup.item != undefined) {
                            if (product_type.find("option[value='"+abcsetup.item.product_type+"']").length) {
                                product_type.val(abcsetup.item.product_type);
                            }
                        }
                    }
                }
            });
        }
    }).trigger("change");

    $("#shipment_dot_iata").change(function() {
        if ($(this).val() == "N") {
            // Reset the CFR fields
            $("#product_regulated_cfr").val("N").trigger('change');
            $("#un_id_cfr").val("").trigger('change');
            // Reset the IATA fields
            $("#product_regulated_iata").val("N").trigger('change');
            $("#un_id_iata").val("").trigger('change');
        }
    }).trigger("change");

    $("#moq").change(function() {
        if ($(this).val() != "Y") {
            // Reset the MOQ fields
            $("#moq_ea").val("");
            $("#moq_ea").after('<input class="moq_ea_hidden" type="hidden" name="moq_ea" value="">');
            $("#moq_pk").val("");
            $("#moq_pk").after('<input class="moq_pk_hidden" type="hidden" name="moq_pk" value="">');
            $("#moq_cs").val("");
            $("#moq_cs").after('<input class="moq_cs_hidden" type="hidden" name="moq_cs" value="">');
        }
        else {
            $('.moq_ea_hidden').remove();
            $('.moq_pk_hidden').remove();
            $('.moq_cs_hidden').remove();
        }
    }).trigger("change");

    // Wholesale unit and PO Identifier changes
    var wholesale_unit_select = $("#wholesale_unit");
    var po_id_select = $("#po_id");

    var uom_codes = {};
    if ($("#type").val() === 'otg' && init_class == 'bluepoint_cm') {
        uom_codes = {
            "NDC": "NDC",
            "UPC": "UPC",
            "VC": "VC",
            "GTIN": "GTIN",
        };
    }
    else {
        uom_codes = {
            "NDC": "NDC",
        };
    }

    var po_id_options = {
        CS: {"": "-select-"},
        PK: {"": "-select-"},
        EA: {"": "-select-"},
    };

    $.each(['CS','PK','EA'], function(uom_idx,uom_val) {
        $.each(uom_codes, function(code_idx,code_val) {
            var t = uom_val+" "+code_idx;
            if (uom_val == "CS" || uom_val == "PK" || uom_val == "EA") {
                po_id_options["CS"][t] = uom_val+" "+code_val;
            }
            if (uom_val == "PK" || uom_val == "EA") {
                po_id_options["PK"][t] = uom_val+" "+code_val;
            }
            if (uom_val == "EA") {
                po_id_options["EA"][t] = uom_val+" "+code_val;
            }
        });
    });

    wholesale_unit_select.change(function() {
        var wholesale_unit = $(this).val();
        // update po_id_select
        if (po_id_select.length) {
            html_select_options_replace({
                select: po_id_select,
                options: po_id_options[wholesale_unit],
                selected: po_id,
            });
        }
    }).trigger("change");

    /*
    * CFR and IATA hazmat
    */
    $("#product_regulated_cfr").change(function() {
        if ($(this).val() == "Y") {
            // Reset the CFR fields
            $("#product_regulated_iata").val("Y").trigger("change");
            $("#product_regulated_iata").attr("disabled",true).parent("td").addClass("readonly");
            $("#product_regulated_iata").after('<input type="hidden" name="product_regulated_iata" value="Y">');
        }
        else {
            if (!$("#product_regulated_iata").hasClass("disabled")) {
                $("#product_regulated_iata").attr("disabled",false).parent("td").removeClass("readonly");
            }
            $("input[name='product_regulated_iata']").remove();
            $("#product_regulated_iata").trigger("change");
        }
    }).trigger("change");

    var hazmat_fields = {
        cfr: [
            "product_regulated",
            "un_id",
            "hazard_class",
            "pack_group",
            "shipping_name_1",
            "label_code",
            "qty_limit_par",
            "qty_limit_cao",
            "vessel_stowage_location",
            "vessel_stowage_other",
        ],
        iata: [
            "product_regulated",
            "un_id",
            "shipping_name",
            "descr",
            "pack_group",
        ],
    };
    var hazmat_types = ['cfr','iata'];
    var hazmat_config = {
        change_field: function(args) {
            // args: hazmat_type, field, data_obj
            console.log("hazmat_config.change_field: args->"+JSON.stringify(args,{},4));
            hazmat_config[args.hazmat_type][args.field+"_select"].obj.empty();
            var list_length = Object.keys(args.data_obj).length;
            if (list_length > 1) {
                hazmat_config[args.hazmat_type][args.field+"_select"].obj.append($("<option></option>").attr("value","").text("-select-"));
            }
            Object.keys(args.data_obj).forEach(function(key) {
                hazmat_config[args.hazmat_type][args.field+"_select"].obj.append($("<option></option>").attr("value",key).text(key));
            });
            if (list_length == 1) {
                hazmat_config[args.hazmat_type][args.field+"_select"].obj.trigger("change", {revalidate: true});
            }
            else {
                if (hazmat_config[args.hazmat_type][args.field+"_select"].obj.find("option[value='"+hazmat_config[args.hazmat_type][args.field+"_select"].val+"']").length) {
                    hazmat_config[args.hazmat_type][args.field+"_select"].obj.val(hazmat_config[args.hazmat_type][args.field+"_select"].val);
                    hazmat_config[args.hazmat_type][args.field+"_select"].obj.trigger("change", {revalidate: true});
                }
            }
        }
    };

    hazmat_types.forEach(function(hazmat_type) {
        hazmat_config[hazmat_type] = {};
        // field objects
        hazmat_fields[hazmat_type].forEach(function(hazmat_field) {
            hazmat_config[hazmat_type][hazmat_field+"_select"] = {};
            hazmat_config[hazmat_type][hazmat_field+"_select"]["obj"] = $("#"+hazmat_field+"_"+hazmat_type);
            hazmat_config[hazmat_type][hazmat_field+"_select"]["val"] = "_undef_";
            if (abcsetup.item != undefined) {
                if (abcsetup.item[hazmat_field+"_"+hazmat_type] != undefined) {
                    hazmat_config[hazmat_type][hazmat_field+"_select"]["val"] = abcsetup.item[hazmat_field+"_"+hazmat_type]
                }
            }
        });
    });

    // add event handlers
    var abc_hazmat_obj = {};
    var selected_hazmat_fields = {};
    hazmat_types.forEach(function(hazmat_type) {
        selected_hazmat_fields[hazmat_type] = {};
        console.log('hazmat event handlers');
        if (!hazmat_config[hazmat_type].un_id_select.obj.is(":disabled")) {
            if (hazmat_type == "cfr") {
                console.log('hazmat event handlers: cfr', hazmat_config[hazmat_type].un_id_select.obj);
                // un_id_select -> hazard_class_select
                hazmat_config[hazmat_type].un_id_select.obj.change(function() {
                    console.log('hazmat event handlers: cfr: un_id change');
                    selected_hazmat_fields[hazmat_type]["un_id"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    $("#hazmat_id_"+hazmat_type).val("");
                    hazmat_fields[hazmat_type].forEach(function(hazmat_field) {
                        if (hazmat_field != "un_id" && hazmat_field != "product_regulated") {
                            hazmat_config[hazmat_type][hazmat_field+"_select"].obj.empty().append($("<option></option>").attr("value","").text("-select-"));
                        }
                    });
                    $.ajax({
                        type: "POST",
                        url: "/abc_item/hazmat_cfr_search",
                        cache: false,
                        dataType: 'json',
                        data: {un_id: un_id},
                        success: function(result) {
                            console.log("item/hazmat_cfr_search[hazard_class]: result->"+JSON.stringify(result,{},4));
                            if (!$.isEmptyObject(result)) {
                                abc_hazmat_obj[hazmat_type] = result;
                                hazmat_config.change_field({
                                    hazmat_type: hazmat_type,
                                    field: "hazard_class",
                                    data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"]
                                });
                            }
                        }
                    });
                });
                // hazard_class_select -> pack_group_select
                hazmat_config[hazmat_type].hazard_class_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["hazard_class"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "pack_group",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group']
                    });
                });
                // pack_group_select -> shipping_name_1_select
                hazmat_config[hazmat_type].pack_group_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["pack_group"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "shipping_name_1",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"]
                    });
                });
                // shipping_name_1_select -> label_code_select
                hazmat_config[hazmat_type].shipping_name_1_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["shipping_name_1"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "label_code",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"]
                    });
                });
                // label_code_select -> qty_limit_par_select
                hazmat_config[hazmat_type].label_code_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["label_code"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "qty_limit_par",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"]
                    });
                });
                // qty_limit_par_select -> qty_limit_cao_select
                hazmat_config[hazmat_type].qty_limit_par_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["qty_limit_par"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "qty_limit_cao",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"]
                    });
                });
                // qty_limit_cao_select -> vessel_stowage_location_select
                hazmat_config[hazmat_type].qty_limit_cao_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["qty_limit_cao"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "vessel_stowage_location",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"]
                    });
                });
                // vessel_stowage_location_select -> vessel_stowage_other_select
                hazmat_config[hazmat_type].vessel_stowage_location_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["vessel_stowage_location"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                    var vessel_stowage_location = selected_hazmat_fields[hazmat_type]["vessel_stowage_location"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "vessel_stowage_other",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"][vessel_stowage_location]["vessel_stowage_other"]
                    });
                });
                // vessel_stowage_other_select
                hazmat_config[hazmat_type].vessel_stowage_other_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["vessel_stowage_other"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                    var vessel_stowage_location = selected_hazmat_fields[hazmat_type]["vessel_stowage_location"];
                    var vessel_stowage_other = selected_hazmat_fields[hazmat_type]["vessel_stowage_other"];
                    var hazmat_id = abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"][vessel_stowage_location]["vessel_stowage_other"][vessel_stowage_other]["hazmat_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    console.log("hazmat_id->"+hazmat_id);
                    $("#hazmat_id_"+hazmat_type).val(hazmat_id);
                });
                if (hazmat_config[hazmat_type].product_regulated_select.obj.val() == "Y") {
                    hazmat_config[hazmat_type].un_id_select.obj.trigger("change");
                }
            }
            else if (hazmat_type == "iata") {
                // un_id_select -> shipping_name_select
                hazmat_config[hazmat_type].un_id_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["un_id"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    $("#hazmat_id_"+hazmat_type).val("");
                    hazmat_fields[hazmat_type].forEach(function(hazmat_field) {
                        if (hazmat_field != "un_id" && hazmat_field != "product_regulated") {
                            hazmat_config[hazmat_type][hazmat_field+"_select"].obj.empty().append($("<option></option>").attr("value","").text("-select-"));
                        }
                    });
                    $.ajax({
                        type: "POST",
                        url: "/abc_item/hazmat_iata_search",
                        cache: false,
                        dataType: 'json',
                        data: {un_id: un_id},
                        success: function(result) {
                            console.log("item/hazmat_iata_search[shipping_name]: result->"+JSON.stringify(result,{},4));
                            if (!$.isEmptyObject(result)) {
                                abc_hazmat_obj[hazmat_type] = result;
                                hazmat_config.change_field({
                                    hazmat_type: hazmat_type,
                                    field: "shipping_name",
                                    data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"]
                                });
                            }
                        }
                    });
                });
                // shipping_name_select -> descr_select
                hazmat_config[hazmat_type].shipping_name_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["shipping_name"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "descr",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr']
                    });
                });
                // descr_select -> pack_group_select
                hazmat_config[hazmat_type].descr_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["descr"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                    var descr = selected_hazmat_fields[hazmat_type]["descr"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "pack_group",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr'][descr]["pack_group"]
                    });
                });
                // pack_group_select
                hazmat_config[hazmat_type].pack_group_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["pack_group"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                    var descr = selected_hazmat_fields[hazmat_type]["descr"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var hazmat_id = abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr'][descr]["pack_group"][pack_group]["hazmat_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    console.log("hazmat_id->"+hazmat_id);
                    $("#hazmat_id_"+hazmat_type).val(hazmat_id);
                });
                if (hazmat_config[hazmat_type].product_regulated_select.obj.val() == "Y") {
                    hazmat_config[hazmat_type].un_id_select.obj.trigger("change");
                }
            }
        }
    });
    $("#organic").change(function(){
        if ($(this).val() == "Y"){
            var inorganic = $("#inorganic").val();
            var sel_value = "";
            if (inorganic != "") {
                sel_value = inorganic;
            }
            else {
                sel_value = "N";
            }
            $("#inorganic").val(sel_value).attr("disabled",true).parent("td").addClass("readonly");
            $("#inorganic").after('<input type="hidden" name="inorganic" value="'+sel_value+'">');
        } else {
            var inorganic = $("#inorganic").val();
            var sel_value = "";
            if (inorganic != "") {
                sel_value = inorganic;
            }
            if (!$("#inorganic").hasClass("disabled")) {
                $("#inorganic").val(sel_value).attr("disabled",false).parent("td").removeClass("readonly");
            }
            $("input[name='inorganic']").remove();
        }
    });
    $("#inorganic").change(function(){
        if ($(this).val() == "Y"){
            var inorganic = $("#organic").val();
            var sel_value = "";
            if (inorganic != "") {
                sel_value = inorganic;
            }
            else {
                sel_value = "N";
            }
            $("#organic").val(sel_value).attr("disabled",true).parent("td").addClass("readonly");
            $("#organic").after('<input type="hidden" name="organic" value="'+sel_value+'">');
        } else {
            var inorganic = $("#organic").val();
            var sel_value = "";
            if (inorganic != "") {
                sel_value = inorganic;
            }
            if (!$("#organic").hasClass("disabled")) {
                $("#organic").val(sel_value).attr("disabled",false).parent("td").removeClass("readonly");
            }
            $("input[name='organic']").remove();
        }
    });
    $("select[name='genitemcatgroup']").change(function(){
        if($(this).val()== "ZFRE") {
            $("input[name='nrfhg']").val("4").attr("readonly",true);
        } else {
            $("input[name='nrfhg']").val("").attr("readonly",true);
        }
    }).trigger("change");
});

function html_select_options_replace(args) {
    // args: select, options, selected

    if (!args.select) {
        return;
    }

    const selected = args.selected || "";
    args.select.children('option').remove();

    for (const value in args.options) {
        if (!args.options.hasOwnProperty(value)) {
            continue;
        }

        const option = $('<option/>', {value, text: args.options[value]});

        if (value && selected == value) {
            option.attr('selected', true);
        }

        option.appendTo(args.select);
    }
}

/*$("#transmit_uom_inner, #transmit_uom_case").change(function() {
    if ($(this).val() == 'Y') {
        $("#transmit_uom_inner").siblings(".form_error").remove();
        $("#transmit_uom_inner").removeClass("form_error");
        $("#transmit_uom_case").siblings(".form_error").remove();
        $("#transmit_uom_case").removeClass("form_error");
    }
}).trigger("change", {initialRun: true});

$("input[name='rx_item[replacement_item_sap]']").change(function(){
    var this_parent = $(this).parent();
    this_parent.find(".invalid_sap").remove();
    $("input[name='rx_item[replacement_item_sap_descr]']").val('');
    var patt1 = /[0-9]+/g;
    var sap_num = $(this).val().match(patt1);
    if (sap_num[0].length == 8) {
        $.ajax({
            type: "POST",
            url: BASE_URL+"/abc_item/view.json",
            dataType: 'json',
            data: {search_fields:{sap_num:sap_num[0]}},
            success: function(result) {
                console_log("abc_item/view.json->"+JSON.stringify(result,{},4));
                if (result.item_record.length) {
                    if (result.item_record[0].name) {
                    $("input[name='rx_item[replacement_item_sap_descr]']").val(result.item_record[0].name.trim());
                    }
                }
                else {
                    this_parent.append('<span class="warning small inForm invalid_sap">The SAP number does not exist</span>');
                }
            }
        });
    }
});

$("input[name='rx_item[sap_item_number]']").change(function() {
    if (user_role == 'field_team') {
        if ($(this).val() != '') {
            $("input[name='rx_item[dup_item_reason]']").closest("tr").show();
            $("textarea[name='rx_item[comments]']").siblings(".input_required_indicator").remove();
        }
        else {
            $("input[name='rx_item[sap_item_descr]']").val('');
            $("input[name='rx_item[dup_item_reason]']").closest("tr").hide();
            $("textarea[name='rx_item[comments]']").siblings(".input_required_indicator").remove();
            $("textarea[name='rx_item[comments]']").after('<span class="input_required_indicator">*</span>');
        }
    }

    if ($(this).val() != '') {
        var this_parent = $(this).parent();
        this_parent.find(".invalid_sap").remove();
        $("input[name='rx_item[sap_item_descr]']").val('');
        var patt1 = /[0-9]+/g;
        var sap_num = $(this).val().match(patt1);
        if (sap_num[0].length == 8) {
            $.ajax({
                type: "POST",
                url: BASE_URL+"/abc_item/view.json",
                dataType: 'json',
                data: {search_fields:{sap_num:sap_num[0]}},
                success: function(result) {
                    console_log("abc_item/view.json->"+JSON.stringify(result,{},4));
                    if (result.item_record.length) {
                    if (result.item_record[0].name) {
                        $("input[name='rx_item[sap_item_descr]']").val(result.item_record[0].name.trim());
                    }
                    }
                    else {
                    this_parent.append('<span class="warning small inForm invalid_sap">The SAP number does not exist</span>');
                    }
                }
            });
        }
    }
}).trigger("change", {initialRun: true});
*/
